/* eslint-disable import/no-named-as-default-member */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { kcContext } from 'config/kc-context';
import { getLocalStorageItem, setLocalStorageItem } from 'utils/storage-utils';
import { PRESAVE_PARAMS } from 'consts/flow-constants';
import { syncWebUiKitLanguageWith, type UniCreditLanguage } from 'web-ui-kit/dist/services/i18n';

import localesEn from 'resources/locales/en.json';
import localesRu from 'resources/locales/ru.json';

const kcLanguage = kcContext?.locale?.currentLanguageTag as UniCreditLanguage;
const localLanguage = getLocalStorageItem(PRESAVE_PARAMS.CURRENT_LOCALE) as UniCreditLanguage;

const resources = {
  ru: {
    translation: {
      ...localesRu,
    },
  },
  en: {
    translation: {
      ...localesEn,
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localLanguage || kcLanguage || 'ru',
    interpolation: {
      escapeValue: false,
    },
    debug: process.env.NODE_ENV === 'development',
  });

syncWebUiKitLanguageWith(i18n);

i18n.on('languageChanged', function (language) {
  setLocalStorageItem(PRESAVE_PARAMS.CURRENT_LOCALE, language);
});

export function addResources(lang: UniCreditLanguage, json: object) {
  i18n.addResourceBundle(lang, 'translation', json);
}

export async function changeLanguage(lang: UniCreditLanguage) {
  await i18n.changeLanguage(lang);
}
